/**
 * ============================================================
 * HUGIFY — Product Add-ons JavaScript
 * Voeg toe aan: assets/product-addons.js
 * En laad via: {{ 'product-addons.js' | asset_url | script_tag }}
 * ============================================================
 *
 * Werking:
 *   - Gratis add-ons (type: "property"):
 *       worden als line item property opgeslagen in de bestelling.
 *       Ze verschijnen zichtbaar in Shopify onder de ordernaam.
 *
 *   - Betaalde add-ons (type: "product"):
 *       worden via de AJAX Cart API als apart product aan het winkelmandje
 *       toegevoegd of verwijderd. Stel in de snippet de correcte variant_id in.
 *
 * ============================================================
 */

(function () {
  'use strict';

  // Wacht tot DOM geladen is
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-addons').forEach(function (container) {
      initAddons(container);
    });
  });

  function initAddons(container) {
    var raw = container.getAttribute('data-addons-config');
    if (!raw) return;

    var addons;
    try {
      addons = JSON.parse(raw.replace(/&quot;/g, '"').replace(/&#39;/g, "'"));
    } catch (e) {
      console.error('[product-addons] Kon configuratie niet laden:', e);
      return;
    }

    var list = container.querySelector('.product-addons__list');
    if (!list) return;

    // Bouw de add-on items
    addons.forEach(function (addon) {
      var item = buildAddonItem(addon);
      list.appendChild(item);
    });

    // Luister naar klikken
    list.addEventListener('change', function (e) {
      var checkbox = e.target.closest('.product-addon-item__checkbox');
      if (!checkbox) return;

      var item = checkbox.closest('.product-addon-item');
      var addonData = JSON.parse(item.getAttribute('data-addon'));
      var checked = checkbox.checked;

      toggleAddon(item, addonData, checked, container);
    });
  }

  /**
   * Bouw een add-on item element
   */
  function buildAddonItem(addon) {
    var priceFormatted = addon.price_cents === 0
      ? '€0,00'
      : '€' + (addon.price_cents / 100).toFixed(2).replace('.', ',');

    var isFree = addon.price_cents === 0;

    var item = document.createElement('label');
    item.className = 'product-addon-item';
    item.setAttribute('data-addon', JSON.stringify(addon));
    item.setAttribute('for', 'addon-' + addon.id);

    item.innerHTML = [
      '<input',
      '  type="checkbox"',
      '  id="addon-' + addon.id + '"',
      '  class="product-addon-item__checkbox"',
      '  data-addon-id="' + addon.id + '"',
      '>',

      '<div class="product-addon-item__check">',
      '  <svg viewBox="0 0 12 10"><polyline points="1,5 4.5,8.5 11,1"/></svg>',
      '</div>',

      '<div class="product-addon-item__icon">',
      addon.icon.startsWith('http') || addon.icon.endsWith('.png') || addon.icon.endsWith('.jpg')
        ? '<img src="' + addon.icon + '" alt="">'
        : addon.icon,
      '</div>',

      '<div class="product-addon-item__content">',
      '  <span class="product-addon-item__title">' + escapeHtml(addon.title) + '</span>',
      addon.description
        ? '<span class="product-addon-item__description">' + escapeHtml(addon.description) + '</span>'
        : '',
      '</div>',

      '<span class="product-addon-item__price' + (isFree ? ' product-addon-item__price--free' : '') + '">',
      priceFormatted,
      '</span>',
    ].join('\n');

    return item;
  }

  /**
   * Verwerk selectie of deselectie van een add-on
   */
  function toggleAddon(item, addon, checked, container) {
    // Visuele feedback
    item.classList.toggle('is-selected', checked);

    if (addon.type === 'property') {
      // Gratis optie. Voeg toe als hidden input in het product formulier.
      updatePropertyInput(addon, checked, container);

    } else if (addon.type === 'product') {
      // Betaalde add-on. Voeg toe aan / verwijder uit winkelmandje via AJAX.
      if (!addon.variant_id || addon.variant_id === 'VERVANG_MET_JOUW_VARIANT_ID') {
        console.warn('[product-addons] Stel een geldige variant_id in voor add-on:', addon.id);
        return;
      }
      item.classList.add('product-addon-item--loading');

      if (checked) {
        addToCart(addon.variant_id, 1, function (success) {
          item.classList.remove('product-addon-item--loading');
          if (!success) {
            // Ongedaan maken bij fout
            item.querySelector('.product-addon-item__checkbox').checked = false;
            item.classList.remove('is-selected');
          }
        });
      } else {
        removeFromCart(addon.variant_id, function (success) {
          item.classList.remove('product-addon-item--loading');
          if (!success) {
            item.querySelector('.product-addon-item__checkbox').checked = true;
            item.classList.add('is-selected');
          }
        });
      }
    }
  }

  /**
   * Voeg of verwijder een hidden input voor gratis line item property
   */
  function updatePropertyInput(addon, checked, container) {
    var productId = container.getAttribute('data-product-id');
    var propertiesDiv = document.getElementById('product-addons-properties-' + productId);
    if (!propertiesDiv) return;

    var existing = propertiesDiv.querySelector('[name="properties[' + addon.title + ']"]');

    if (checked) {
      if (!existing) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + addon.title + ']';
        input.value = 'Ja';
        propertiesDiv.appendChild(input);
      }

      // Verplaats naar het product formulier als dat bestaat
      var form = document.querySelector('form[action="/cart/add"]');
      if (form && existing) {
        form.appendChild(existing.cloneNode(true));
      }
    } else {
      if (existing) existing.remove();
      // Verwijder ook uit formulier
      var form = document.querySelector('form[action="/cart/add"]');
      if (form) {
        var inForm = form.querySelector('[name="properties[' + addon.title + ']"]');
        if (inForm) inForm.remove();
      }
    }
  }

  /**
   * AJAX: voeg variant toe aan winkelmandje
   */
  function addToCart(variantId, quantity, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Fout bij toevoegen aan winkelmandje');
        return res.json();
      })
      .then(function () {
        // Ververs de winkelwagen-widget als die bestaat
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        callback(true);
      })
      .catch(function (err) {
        console.error('[product-addons] addToCart fout:', err);
        callback(false);
      });
  }

  /**
   * AJAX: verwijder variant uit winkelmandje
   */
  function removeFromCart(variantId, callback) {
    // Haal eerst de huidige cart op om de line item key te vinden
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var lineItem = cart.items.find(function (item) {
          return String(item.variant_id) === String(variantId);
        });
        if (!lineItem) {
          callback(true);
          return;
        }
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineItem.key, quantity: 0 })
        });
      })
      .then(function (res) {
        if (res && !res.ok) throw new Error('Fout bij verwijderen uit winkelmandje');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        callback(true);
      })
      .catch(function (err) {
        console.error('[product-addons] removeFromCart fout:', err);
        callback(false);
      });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

})();
